import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { OptionService } from '@root/router/index/option.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { filter } from 'rxjs';
import { EditHouseComponent } from '../edit-house/edit-house.component';
import { PropertyDetailService, PageData } from './property-detail.service';
import { ModalService } from '@root/router/index/modal.service';

@Component({
  selector: 'host-property-detail',
  templateUrl: './property-detail.component.html',
  styleUrls: ['./property-detail.component.scss'],
})
export class PropertyDetailComponent implements OnInit, OnDestroy {
  readonly detailApi = '/api/house/details';
  private readonly saveTagsApi = '/api/house/save_tags';
  @Input() id;
  // @Input() operationList: any[] = [];
  @Input() tab = 0;
  @Input() appendPageData: any = null;
  @ViewChild('editTag') editTag: TemplateRef<any>;
  houseDetail;

  tagEditing = false;
  tagIds;

  calendarDrawerRef;
  // get optionsOfHouseTag() {
  //   return this.optSrv.optionsOfHouseTag;
  // }

  optionsOfHouseTag = [];

  constructor(
    private pdSrv: PropertyDetailService,
    private globalModal: ModalService,
    private http: HttpClient,
    private drawerRef: NzDrawerRef,
    private optSrv: OptionService,
    private modal: NzModalService,
    private msg: NzMessageService,
    private router: Router,
    private ele: ElementRef,
    private t: TranslateService
  ) {}

  ngOnInit() {
    this.initTagOption();
    this.initHouseDetail();

    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());

    // this.pdSrv.operationList$.pipe(filter((list) => list?.[0])).subscribe(rst => {

    // });

    // if (this.operationList?.length) {
    //   this.pdSrv.operate(this.operationList);
    // }
    // if (this.appendPageData) {
    //   const map = {
    //     0: 'basic',
    //     1: 'rules',
    //     2: 'linked',
    //   };
    //   this.pdSrv.changePageData({ page: map[this.tab], data: this.appendPageData });
    // }
  }

  ngOnDestroy(): void {
    this.calendarDrawerRef?.close();
  }

  // @HostListener("click", ["$event"])
  handleGlobalClick(event) {
    if (this.tagEditing) {
      this.requestSaveTags();
    }
  }

  initTagOption() {
    this.http.get('/api/house_status_setting/get').subscribe((rst: any) => {
      this.optionsOfHouseTag = rst?.data?.house_tag
        .filter((t) => !t.delete_time)
        .map((t) => ({
          label: t.name,
          value: t.id,
          color: t.color,
        }));
    });
  }

  private initHouseDetail() {
    const params = { house_id: this.id };
    this.http.get(this.detailApi, { params }).subscribe((rst: any) => {
      this.houseDetail = rst?.data;

      this.tagIds = this.houseDetail?.tags?.map((t) => t.id);
      console.log('this.houseDetail: ', this.houseDetail);
    });
  }

  onTagOpenChange(open) {
    // console.log("open: ", open);
    // if (!open) {
    //   this.requestSaveTags();
    // }
  }

  autoFocusSelect() {
    setTimeout(() => {
      const se = this.ele.nativeElement.querySelector('._antd-select');
      if (!this.tagIds?.length) {
        se.click();
      }
    }, 300);
  }

  onSubpageNavigate() {
    this.ele.nativeElement.querySelector('.ant-tabs-content-holder').scrollTop = 0;
  }

  onEditHouse() {
    const modal = this.modal.create({
      nzTitle: this.t.t('word.edit'),
      nzContent: EditHouseComponent,
      nzWidth: 500,
      nzFooter: null,
      nzComponentParams: {
        type: 'house',
        data: {
          id: this.id,
          cover: this.houseDetail?.cover_url,
          title: this.houseDetail?.house_title,
        },
      },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst?.status === 'ok') {
        this.initHouseDetail();
      }
    });
  }

  onDisplayCalendar() {
    this.calendarDrawerRef = this.globalModal.displayPropertyCalendarDrawer(this.id);
  }

  onRemoveHouse() {
    this.displayRemoveHouseWarning().subscribe(() => {
      this.http.post('/api/house_relation/remove_relation', { house_id: this.id }).subscribe((rst: any) => {
        if (rst.error_code === 0) {
          this.msg.success(this.t.t('word.removed'));
          // this.initHouseDetail();
          this.drawerRef?.close();
        }
      });
    });
  }

  toSettingOptionPage() {
    this.router.navigate(['/app/settings/custom-options'], { queryParams: { anchor: 'tags' } });
    // this.drawerRef.close();
  }

  private displayRemoveHouseWarning() {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: this.t.t('property-property_detail_ts_删除标题'),
        nzContent: this.t.t('property-property_detail_ts_删除内容'),
        nzOkText: this.t.t('word.yes'),
        nzWidth: 500,
        nzOnOk: () => observer.next(null),
      });

      modal.afterClose.subscribe(() => observer.complete());
    });
  }

  private requestSaveTags() {
    const params = {
      house_id: this.id,
      house_tag_ids: this.tagIds,
    };
    this.http.post(this.saveTagsApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.initHouseDetail();
        this.tagEditing = false;
      }
    });
  }

  onClose() {
    this.drawerRef.close();
  }
}
